import type { FC, ReactNode } from 'react';
import { ModalsProvider } from '@mantine/modals';

import classes from './modal.module.css';

interface ModalsProviderWrapperProps {
  children?: ReactNode;
}

/**
 * ### ModalsProviderWrapper
 *
 * @description
 * Mounts Mantine's `ModalsProvider`, which the imperative modal helpers need — `useConfirmModal`,
 * `useConfirmDeleteModal`, and the few call sites that open a modal through `openModal`. It
 * registers no named modals: declarative modals use `Modal` or `ActionModal` directly.
 *
 * `classNames.body` gives those prompts the same fixed action row as `Modal`: Mantine builds their
 * body children itself, so the split into a scrolling region and a pinned button row has to be
 * described in CSS rather than rendered (see modal.module.css).
 *
 * @param props - children rendered inside the provider
 * @returns React component
 */
export const ModalsProviderWrapper: FC<ModalsProviderWrapperProps> = (props) => {
  const { children } = props;

  return (
    <ModalsProvider modalProps={{ centered: true, classNames: { body: classes.confirmBody } }}>
      {children}
    </ModalsProvider>
  );
};
